// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"249":"ffe28ceb","970":"ffe28ceb"}[chunkId] + ".css";
};